// extracted by mini-css-extract-plugin
export default {"videoResponsive":"VideoEmbed_videoResponsive__EIHeB"};